import {
  EXCLUDE_BASIC_PACKAGE,
  EXCLUDE_PREMIUM_PACKAGE,
  SIDEBAR_WIDTH,
} from "../../constants/constant";
import Header from "../../ui/Header";
import SidebarComponents from "../../ui/SidebarComponents";
import NotFound from "../../../assets/images/not_found.png";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useProSidebar } from "react-pro-sidebar";

/**
  Component to wrap every page that has a header and sidebar
*/

const PageTemplate = ({
  header,
  breadcrumb,
  mainComponent,
  pageRole,
  noPadding,
  bgColor,
  checkOwner,
  requiredTitle,
}) => {
  const navigate = useNavigate();
  const { broken } = useProSidebar();
  const packageStatus = localStorage.getItem("package");
  const roles = localStorage.getItem("roles");
  const titleId = localStorage.getItem("title");

  if (!roles && !packageStatus) {
    navigate("/");
  }

  const getPageTitle = () => {
    return header && header !== ""
      ? "OLIN - " + header
      : pageRole === 3
      ? "OLIN - Purchase"
      : "OLIN";
  };

  const isIncludePackage = () => {
    if (Number(packageStatus) === 1 && EXCLUDE_BASIC_PACKAGE.includes(pageRole))
      return false;
    if (
      Number(packageStatus) === 2 &&
      EXCLUDE_PREMIUM_PACKAGE.includes(pageRole)
    )
      return false;
    return true;
  };

  const userHasAccess = () => {
    // has access if user's package status has it & included in its own list of roles
    // TODO: add access for reporting children, discount, pelanggan for exclude basic package
    if ((pageRole === undefined || pageRole === null) && !checkOwner)
      return false;
    if (!isIncludePackage()) return false;
    if (pageRole === 0) return true;
    if (checkOwner !== undefined) return Number(titleId) === 1; // allow access to dashboard, discount, pelanggan, sales, settings if owner
    if (requiredTitle !== undefined) return Number(titleId) === requiredTitle; // job title decides, not user-management roles

    return roles?.includes(pageRole);
  };

  return (
    <div
      className={`${
        bgColor
          ? bgColor === "gray"
            ? "bg-[#F7F8F9]"
            : bgColor === "gradient-blue-amanah"
            ? "bg-gradient-to-b from-[#4DABE90D] to-[#4DABE9CC]"
            : ""
          : ""
      }`}
    >
      <Helmet>
        <title>{getPageTitle()}</title>
      </Helmet>
      <div className="flex">
        <SidebarComponents />
        <div
          className={`w-full lg:w-[calc(100%-${SIDEBAR_WIDTH}px)] overflow-hidden`}
        >
          <div className={`${header || breadcrumb ? "p-3 pb-0" : ""}`}>
            <Header />
            {header ? (
              <div
                className={`font-semibold text-[20px] lg:text-[24px] mb-2 text-left ${
                  broken ? "pt-[50px]" : ""
                }`}
              >
                {header}
              </div>
            ) : null}
            {breadcrumb ? (
              <div className=" hidden lg:block">{breadcrumb}</div>
            ) : null}
          </div>
          <div className={`${noPadding ? "" : "px-3"}`}>
            {userHasAccess() ? (
              <div className={`${noPadding ? "" : "mt-4 lg:mt-0"}`}>
                {mainComponent}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center pb-4 h-full min-h-[50vh] ">
                <div>
                  <img src={NotFound} className="w-[150px]" />
                </div>
                <p className="text-xl align-center mt-8">
                  Anda belum memiliki akses ke fitur ini
                </p>
                <p className="text-gray-400">
                  {isIncludePackage()
                    ? "Silahkan hubungi owner"
                    : "Silahkan upgrade subscription OLIN anda"}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageTemplate;
